import { Ban, MessageSquareText, PenSquare, Reply } from "lucide-react";
import { useCallback, useEffect, useState } from "react";

import { api } from "@/api";
import { timeAgo } from "@/components/projects/common";
import { SmsCompose } from "@/components/steps/SmsCompose";
import "@/steps.css";

export function SmsInbox({ onRead }) {
  const [threads, setThreads] = useState([]);
  const [filter, setFilter] = useState("replies");
  const [current, setCurrent] = useState(null);
  const [messages, setMessages] = useState([]);
  const [compose, setCompose] = useState(null);
  const load = useCallback(() => api.get("/sms/threads").then(({ data }) => setThreads(data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  const open = async (t) => { setCurrent(t); const { data } = await api.get(`/sms/threads/${encodeURIComponent(t.phone)}`); setMessages(data); load(); onRead(); };
  const shown = threads.filter((t) => (filter === "replies" ? t.has_reply : filter === "stop" ? t.stop : true));
  return (
    <section className="page sms-inbox" data-testid="sms-inbox">
      <header className="page-heading"><div><p className="eyebrow">RÉPONSES</p><h1>Réponses aux SMS</h1><p className="page-subtitle">Réponses et STOP reçus sur les SMS envoyés par vos automatisations. Un numéro qui a répondu STOP ne reçoit plus aucun SMS automatique.</p></div>
        <div className="button-row"><button type="button" className="primary-button" onClick={() => setCompose({ phone: "", leadId: null })} data-testid="sms-new-btn"><PenSquare size={15} /> Nouveau SMS</button></div>
      </header>
      <div className="pj-seg pj-mb">
        {[["replies", "Avec réponse"], ["stop", "STOP"], ["all", "Tous les SMS"]].map(([k, l]) => <button key={k} type="button" className={filter === k ? "is-on" : ""} onClick={() => setFilter(k)} data-testid={`sms-filter-${k}`}>{l}</button>)}
      </div>
      <div className="sms-layout">
        <ul className="sms-threads" data-testid="sms-threads">
          {shown.length === 0 && <li className="pj-empty">Aucune conversation.</li>}
          {shown.map((t) => (
            <li key={t.phone}><button type="button" className={current?.phone === t.phone ? "is-on" : ""} onClick={() => open(t)} data-testid={`sms-thread-${t.phone}`}>
              <div><strong>{t.lead_title || t.phone}</strong><small>{t.phone}</small><p>{t.last_text}</p></div>
              <span className="sms-side"><small>{timeAgo(t.last_at)}</small>{t.stop && <span className="pj-pill is-guest"><Ban size={11} />STOP</span>}{t.unread > 0 && <span className="nav-badge">{t.unread}</span>}</span>
            </button></li>
          ))}
        </ul>
        <div className="sms-thread" data-testid="sms-thread-view">
          {!current ? <p className="pj-empty"><MessageSquareText size={16} /> Choisissez une conversation.</p> : (
            <>
              <header>
                <div><strong>{current.lead_title || current.phone}</strong><small>{current.phone}{current.lead_id ? ` · lead noCRM n° ${current.lead_id}` : ""}</small></div>
                {!current.stop && <button type="button" className="secondary-button" onClick={() => setCompose({ phone: current.phone, leadId: current.lead_id })} data-testid="sms-reply-btn"><Reply size={14} /> Répondre</button>}
              </header>
              <div className="sms-bubbles">{messages.map((m) => <div key={m.id} className={`sms-bubble is-${m.direction} ${m.kind === "stop" ? "is-stop" : ""}`}><p>{m.text}</p><small>{m.direction === "out" ? m.rule_name : m.kind === "stop" ? "STOP — désinscrit" : "Réponse"} · {timeAgo(m.created_at)}</small></div>)}</div>
            </>
          )}
        </div>
      </div>
      <SmsCompose open={Boolean(compose)} onOpenChange={(o) => !o && setCompose(null)} phone={compose?.phone || ""} leadId={compose?.leadId} onSent={(m) => { load(); if (current?.phone === m.phone) setMessages((list) => [...list, m]); }} />
    </section>
  );
}
